// @ts-nocheck
/**
 * This module is used to apply the consent management settings for a given
 * user. It will listen for changes to the consent state and update the trackers
 * accordingly.
 *
 * @module applyConsentManagement
 */
import { updateTrackerConsentState } from '@/lib/tracking';
import Events from '@/constants/events';
import store from '@/store';
import { handleError } from '@/utilities';

function updateTrackers() {
  store.updateTrackersModified();
  updateTrackerConsentState();
}

export function applyConsentManagement() {
  try {
    const {
      config: {
        regionTemplate: {
          settings: { consent: { blockingMode: mode = 'disabled' } = {} } = {},
        } = {},
      } = {},
    } = store;

    if (mode === 'disabled') {
      return;
    }

    /* Apply any consent state we have. */
    updateTrackers();

    /* Listen for changes to the consent state and update the trackers. */
    window.addEventListener(Events.ConsentStateChanged, updateTrackers);
  } catch (err) {
    handleError(err);
  }
}
